import { currencyFormatter } from "../../../../../utils/formatter/formatter";
import { STORE_STATUS_STYLE } from "../oportunidadesSortimento.data";

const DARK_GREEN = "#15803d";

// ícone do conector entre as 2 colunas do painel
const ConnectorTrendingIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 7h6v6" /><path d="m22 7-8.5 8.5-5-5L2 17" />
  </svg>
);

// ícones (lucide) usados nas caixinhas de RANKING e nas caixas DIAGNÓSTICO/AÇÃO
const AwardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
    <circle cx="12" cy="8" r="6" />
  </svg>
);
const StoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" />
    <path d="M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244" />
    <path d="M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" />
  </svg>
);
const TrendingDownIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 17h6v-6" /><path d="m22 17-8.5-8.5-5 5L2 7" />
  </svg>
);
const TargetIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);
const LightbulbIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
    <path d="M9 18h6" /><path d="M10 22h4" />
  </svg>
);

// caixinha do card RANKING — ícone colorido à esquerda + label/valor/legenda à direita
const RankingStat = ({ icon, label, value, caption, valueColor = "#333" }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, backgroundColor: "#fff", border: "1px solid #efefef", borderRadius: "8px", padding: "10px 12px" }}>
    <span style={{
      width: 36, height: 36, borderRadius: "8px", backgroundColor: "#fde8d5",
      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#E8773A",
    }}>
      {icon}
    </span>
    <div>
      <p style={{ fontSize: "10px", fontWeight: "700", color: "#aaa", letterSpacing: "0.03em", marginBottom: 2 }}>{label}</p>
      <p style={{ fontSize: "18px", fontWeight: "800", color: valueColor, margin: 0 }}>{value}</p>
      {caption && <p style={{ fontSize: "10.5px", color: "#bbb", marginTop: 2 }}>{caption}</p>}
    </div>
  </div>
);

// pill "ausente/presente" — mesma convenção do TierTag em StorePlanList.jsx
const StoreStatusPill = ({ status }) => {
  const style = STORE_STATUS_STYLE[status] || STORE_STATUS_STYLE.ausente;
  return (
    <span style={{
      padding: "2px 10px", borderRadius: "6px", fontSize: "11px", fontWeight: "700",
      color: style.color, backgroundColor: style.bg, border: `1px solid ${style.border}`,
    }}>
      {status}
    </span>
  );
};

export const OpportunityDetailPanel = ({ opportunity }) => {
  const { ranking, share, diagnostic, recommendedAction, stores } = opportunity;
  const totalReturn = stores.reduce((sum, s) => sum + s.expectedReturn, 0);
  const maxReturn = Math.max(...stores.map((s) => s.expectedReturn));

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.1fr 44px 0.9fr", padding: "18px 20px", backgroundColor: "#fafafa" }}>

      {/* coluna esquerda */}
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

        {/* card RANKING — cabeçalho branco com barrinha laranja */}
        <section style={{ border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden", background: "#fff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 14px", backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0" }}>
            <span style={{ width: 3, height: 14, backgroundColor: "#E8773A", borderRadius: 3 }} />
            <p style={{ fontSize: "11px", fontWeight: "700", color: "#333" }}>RANKING</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, padding: "12px 14px" }}>
            <RankingStat icon={<AwardIcon />} valueColor="#16a34a" label="RANK EM POA" value={`#${ranking.rankPoa}`} caption={`${currencyFormatter.format(ranking.poaAnnualValue)}/ano`} />
            <RankingStat icon={<StoreIcon />} valueColor="#be123c" label="RANK NA CENTERSHOP" value={`#${ranking.rankCenterShop}`} caption={`${currencyFormatter.format(ranking.centerShopAnnualValue)}/ano`} />
            <RankingStat icon={<TrendingDownIcon />} valueColor="#1a1a1a" label="GAP DE POSIÇÕES" value={ranking.gap} caption="posições atrás" />
          </div>
        </section>

        {/* card SHARE / DIAGNÓSTICO / AÇÕES — mesmo cabeçalho do card RANKING */}
        <section style={{ border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden", background: "#fff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 14px", backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0" }}>
            <span style={{ width: 3, height: 14, backgroundColor: "#E8773A", borderRadius: 3 }} />
            <p style={{ fontSize: "11px", fontWeight: "700", color: "#333" }}>SHARE / DIAGNÓSTICO / AÇÕES</p>
          </div>

          <div style={{ padding: "12px 14px" }}>
            <p style={{ fontSize: "12px", color: "#666", marginBottom: 4 }}>
              Center Shop vende {currencyFormatter.format(share.centerShopSales)} de {currencyFormatter.format(share.poaSales)} em Porto Alegre
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ flex: 1, height: 6, borderRadius: 3, background: "#f0f0f0" }}>
                <div style={{ height: "100%", borderRadius: 3, backgroundColor: "#dc2626", width: `${share.percentage * 100}%` }} />
              </div>
              <span style={{ fontSize: "12px", fontWeight: "700", color: "#333" }}>{(share.percentage * 100).toFixed(1)}%</span>
            </div>

          {/* caixa DIAGNÓSTICO — fundo branco, só a borda cinza */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 12, background: "#fff", border: "1px solid #ddd", borderRadius: "8px", padding: "10px 12px" }}>
            <span style={{
              width: 32, height: 32, borderRadius: "8px", backgroundColor: "#fde8d5",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#E8773A",
            }}>
              <TargetIcon />
            </span>
            <div>
              <p style={{ fontSize: "10px", fontWeight: "700", color: "#aaa", letterSpacing: "0.03em" }}>DIAGNÓSTICO</p>
              <p style={{ fontSize: "12px", color: "#555" }}>{diagnostic}</p>
            </div>
          </div>

            {/* caixa AÇÃO RECOMENDADA — mesmo verde do banner de Qualificação de MIX */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, background: "#f2fbf5", border: "1px solid #cdeedb", borderRadius: "8px", padding: "10px 12px" }}>
              <span style={{
                width: 32, height: 32, borderRadius: "8px", backgroundColor: "#dcfce7",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#16a34a",
              }}>
                <LightbulbIcon />
              </span>
              <div>
                <p style={{ fontSize: "10px", fontWeight: "700", color: DARK_GREEN, letterSpacing: "0.03em" }}>AÇÃO RECOMENDADA</p>
                <p style={{ fontSize: "12px", color: DARK_GREEN, fontWeight: "600" }}>{recommendedAction}</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* coluna do meio, dedicada só ao conector — assim ele nunca sobrepõe as outras colunas */}
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: 0, bottom: 0, left: "50%", width: 1, backgroundColor: "#f3c9a0", transform: "translateX(-50%)" }} />
        <span style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: 36, height: 36, borderRadius: "50%", backgroundColor: "#E8773A",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)", zIndex: 2,
        }}>
          <ConnectorTrendingIcon />
        </span>
      </div>

      {/* coluna direita: RETORNO ESPERADO — tabela por loja igual ao padrão do RankingTable.jsx */}
      <section style={{ border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden", background: "#fff", height: "fit-content" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 14px", backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0" }}>
          <span style={{ width: 3, height: 14, backgroundColor: "#E8773A", borderRadius: 3 }} />
          <p style={{ fontSize: "11px", fontWeight: "700", color: "#333" }}>RETORNO ESPERADO</p>
        </div>

        <div style={{ margin: "12px 14px", background: "#f2fbf5", border: "1px solid #cdeedb", borderRadius: "8px", padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: "11px", fontWeight: "700", color: DARK_GREEN }}>TOTAL ESTIMADO</span>
          <span style={{ fontSize: "18px", fontWeight: "800", color: DARK_GREEN }}>{currencyFormatter.format(totalReturn)}</span>
        </div>

        <div style={{ margin: "0 14px 14px", border: "1px solid #eee", borderRadius: "8px", overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["LOJA", "PORTE", "STATUS", "RETORNO (×30%)"].map((h) => (
                  <th key={h} style={{ padding: "8px 14px", fontSize: "10px", fontWeight: "700", color: "#888", textAlign: "left", backgroundColor: "#f8f9fb", borderBottom: "1px solid #eee" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stores.map((store, index) => (
                <tr key={store.id}>
                  <td style={{ padding: "8px 14px", fontSize: "12px", fontWeight: "600", color: "#1a1a1a", borderBottom: index < stores.length - 1 ? "1px solid #f0f0f0" : "none" }}>{store.name}</td>
                  <td style={{ padding: "8px 14px", fontSize: "12px", color: "#666", borderBottom: index < stores.length - 1 ? "1px solid #f0f0f0" : "none" }}>{store.tier}</td>
                  <td style={{ padding: "8px 14px", borderBottom: index < stores.length - 1 ? "1px solid #f0f0f0" : "none" }}><StoreStatusPill status={store.status} /></td>
                  <td style={{ padding: "8px 14px", minWidth: 140, borderBottom: index < stores.length - 1 ? "1px solid #f0f0f0" : "none" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ flex: 1, height: 6, borderRadius: 3, background: "#f0f0f0" }}>
                        <div style={{ height: "100%", borderRadius: 3, backgroundColor: "#E8773A", width: `${(store.expectedReturn / maxReturn) * 100}%` }} />
                      </div>
                      <span style={{ fontSize: "12px", fontWeight: "700", color: "#666", whiteSpace: "nowrap" }}>{currencyFormatter.format(store.expectedReturn)}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};
